import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventResponse, Push, PushObject, PushOptions } from '@ionic-native/push';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, App, NavController, Platform } from 'ionic-angular';
import { Observable, Subject } from 'rxjs';
import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import { MysportContactsPage } from '../../pages/me/mysport/mysport-contacts/mysport-contacts';
import { MysportEventsPage } from '../../pages/me/mysport/mysport-events/mysport-events';
import { MysportPhotosPage } from '../../pages/me/mysport/mysport-photos/mysport-photos';
import { MysportResultsPage } from '../../pages/me/mysport/mysport-results/mysport-results';
import { ResultDetailsPage } from '../../pages/results/result-details/result-details';
import { ResultProfilePage } from '../../pages/results/result-profile/result-profile';
import { ResultRanglistPage } from '../../pages/results/result-ranglist/result-ranglist';
import { ConfigProvider } from '../config/config';
import { EventDetailsModel, EventProvider, MyEventListModel } from '../event/event';
import { LoaderProvider } from '../loader/loader';
import { ResultListModel, ResultProvider } from '../result/result';
import { MySportProfileListItem, UserProvider } from '../user/user';
import { ValueProvider } from '../value/value';
import { NewsProvider } from '../news/news';
import { NotificationDetailsPage } from '../../pages/notification/details/notification-details';

/*
  Generated class for the NotificationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotificationProvider {

  private channelId: string = "spooortsChannel";
  private channelDescription: string = "Channel for receiving notification from spooorts";
  private pushObj: PushObject = null;
  private registration: Subject<Object>[] = [];
  private recive: Subject<Object>[] = [];
  private token: string = null;
  private notificationToken = null;

  options: PushOptions = {
    android: {
      senderID: '',
      icon: "res://notification"
    },
    ios: {
      alert: 'true',
      badge: true,
      sound: 'false'
    },
    windows: {}
  };

  constructor(public http: HttpClient,
    private push: Push,
    private platform: Platform,
    private config: ConfigProvider,
    private eventService: EventProvider,
    private resultService: ResultProvider,
    private loadingCtrl: LoaderProvider,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private userService: UserProvider,
    private valueService: ValueProvider,
    private newsService: NewsProvider,
    private app: App
  ) {
    // new Promise<any>(async (resolve, reject) => {
    //   this.options.android.senderID = (await this.config.config).push.senderID;
    //   (window as any).appp = this.push;
    //   (window as any).tppp = this;
    //   this.canReceivePushNotifications().then((can) => {
    //     if (can) {
    //       platform.ready().then(() => {

    //         this.pushObj = this.push.init(this.options);
    //         (window as any).ppp = this.pushObj;

    //         this.pushObj.on('notification').subscribe((notification: any) => {
    //           console.log('Received a notification' + notification);
    //           if ((window as any).recivedNot) {
    //             (window as any).recivedNot = [];
    //           }

    //           this.alertCtrl.create({
    //             title: notification.additionalData.Title,
    //             message: notification.message,
    //             buttons: [
    //               {
    //                 text: 'Cancel',
    //                 role: 'cancel',
    //                 cssClass: 'secondary',
    //                 handler: (blah) => {
    //                   console.log('Confirm Cancel: blah');
    //                 }
    //               }, {
    //                 text: 'Open',
    //                 handler: () => {
    //                   this.handleNotification(notification);
    //                 }
    //               }
    //             ]
    //           }).present();
    //           this.recive.forEach((rec) => {
    //             rec.next(notification);
    //           });
    //         });

    //         this.pushObj.on('registration').subscribe((reg) => {
    //           console.log("Notification registered" + reg.registrationId);
    //           this.notificationToken = reg.registrationId;
    //           this.token = reg.registrationId;
    //           (window as any).rppp = reg;
    //           this.registration.forEach((registration) => {
    //             registration.next(reg.registrationId);
    //           })
    //         });

    //         this.pushObj.on('error').subscribe(error => console.error('Error with Push plugin' + error));
    //       });
    //     }
    //   });
    // });
  }

  public register(): Promise<string> {
    return new Promise((resolve, reject) => {
      resolve(this.notificationToken)
    });
  }

  public init() {

  }

  public async canReceivePushNotifications(): Promise<boolean> {
    return !(await this.config.config).platform.browser;
  };

  async getNotificationToken(): Promise<String> {
    try {

      if ((await this.push.hasPermission()).isEnabled) {
        if (this.token) {
          return this.token;
        } else {
          const sub = new Subject<string>();
          this.registration.push(sub);
          const token = await sub.toPromise();
          return token;
        }
      } else {
        return null;
      }
    } catch {
      return null;
    }

  }

  async onRegistration(): Promise<Observable<EventResponse>> {
    if (await this.canReceivePushNotifications()) {
      await this.platform.ready();
      return this.pushObj.on('registration');
    } else {
      return;
    }
  }

  async onRecive(): Promise<Observable<any>> {
    await this.platform.ready();
    return this.pushObj.on('notification');
  }

  createChannel() {
    return new Promise((resolve, reject) => {
      this.push.listChannels().then((channels) => {
        if (channels.length === 0) {
          this.push.createChannel({
            id: this.channelId,
            description: this.channelDescription,
            importance: 3
          }).then(() => resolve(null));
        } else {
          resolve(null);
        }
      });
    });
  }

  private handleNotification(notification: any) {
    let data = notification.additionalData;
    if (data.Page) {
      switch (data.Page) {
        case "Event":
          if (data.Id) {
            // let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.eventService.getEventDetails(data.Id).then((event: EventDetailsModel) => {
              (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event })
                .then(() => {
                  // loader.dismiss()
                });
            });
          }
          break;

        case "Result":
          if (data.Id) {
            // let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.resultService.getResult(data.Id).then((result: ResultListModel) => {
              this.app.getRootNav().push(ResultDetailsPage, { result: result })
                .then(() => {
                  // loader.dismiss()
                });
            });
          }
          break;

        case "Profile":
          if (data.Id) {
            // let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
          }
          break;

        case "Ranglist":
          if (data.Id) {
            // let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();

            let searchModel = { eid: "" + data.Id, ename: "", limit: 25 + "", page: 1 + "", start: 0 + "" };

            this.resultService.getRangList(searchModel)
              .then((data) => {
                console.log(data);
                (this.app.getRootNav() as NavController).push(ResultRanglistPage, { data: { list: data, search: searchModel } })
                  .then(() => {
                    // loader.dismiss()
                  });
              })
          }
          break;

        case "MyPhotos":
          if (data.Id) {
            // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.userService.getMyPhotos().then((pictures) => {
              (this.app.getRootNav() as NavController).push(MysportPhotosPage, { pictures: pictures })
                .then(() => {
                  // loader.dismiss()
                });
            })
          }
          break;

        case "MyResults":
          if (data.Id) {
            // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.userService.getMyResults().then((results) => {
              (this.app.getRootNav() as NavController).push(MysportResultsPage, { results: results })
                .then(() => {
                  // loader.dismiss()
                });
            })
          }
          break;

        case "MyEvents":
          if (data.Id) {
            // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();

            this.eventService.getMyEvents().then((value: MyEventListModel[]) => {
              (this.app.getRootNav() as NavController).push(MysportEventsPage, { data: value })
                .then(() => {

                });
              // loader.dismiss()
            });
          }
          break;

        case "MyFriends":
          if (data.Id) {
            // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.userService.getMyFriends().then((friendList: MySportProfileListItem[]) => {
              this.userService.getMyFans().then((fanList) => {
                (this.app.getRootNav() as NavController).push(MysportContactsPage, { friendList: friendList, fanList: fanList, page: "friends" })
                  .then(() => {
                    // loader.dismiss()
                  });
              });
            })
          }
          break;

        case "MyFans":
          if (data.Id) {
            // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.userService.getMyFriends().then((friendList: MySportProfileListItem[]) => {
              this.userService.getMyFans().then((fanList) => {
                (this.app.getRootNav() as NavController).push(MysportContactsPage, { friendList: friendList, fanList: fanList, page: "fans" })
                  .then(() => {
                    // loader.dismiss()

                  });
              });
            })
          }
          break;


        case "News":
          if (data.Id) {
            // var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
            // loader.present();
            this.newsService.getNews(data.Id).then(results => {
              (this.app.getRootNav() as NavController).push(NotificationDetailsPage, { news: results }).then(() => {
                // loader.dismiss();
              });
            });
          }
          break;

        default:
          break;
      }

    }

  }

}




// WEBPACK FOOTER //
// /src/providers/notification/notification.ts